import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudButtonModule,
	FreudCardModule,
	FreudLoaderModule,
	FreudSelectModule,
	FreudTagModule,
	FreudTooltipModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { MoodTrackerReportCardModule } from '../moodtracker-report-card/moodtracker-report-card.module';
import { ContactMoodtracker } from './contact-moodtracker.component';

@NgModule({
	declarations: [ContactMoodtracker],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudButtonModule,
		FreudSelectModule,
		FreudTagModule,
		MoodTrackerReportCardModule,
		FreudTooltipModule,
		FreudCardModule,
		FreudLoaderModule,
	],
	exports: [ContactMoodtracker],
	providers: [],
})
export class ContactMoodtrackerModule {}
